import { Autocomplete, Paper, Skeleton, TextField } from '@mui/material'
import React from 'react'

function CustomAutoCompleteDropdown({
  name,
  placeholder,
  options,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  isDisabled,
  autoFocus,
  allowClear = true,
  readOnly = false,

  // NEW
  isLoading = false,
}) {

  const ModifiedAutoComplete = {
    '& .MuiOutlinedInput-root': {
      fontFamily: 'Poppins',
      fontSize: '15px',
      '& fieldset': { borderColor: '#C0C0C0' },
      '&:hover fieldset': { borderColor: '#C0C0C0' },
      '&.Mui-focused fieldset': { borderColor: '#C0C0C0' },
    },
    "& .MuiInputBase-input.Mui-disabled": {
      WebkitTextFillColor: "#272727",
    },
  };

  // 🔥 NEW → Replace with Skeleton during loading
  if (isLoading) {
    return (
      <Skeleton
        variant="rounded"
        height={40}
        sx={{ borderRadius: "6px" }}
      />
    );
  }

  return (
    <div>
      <Autocomplete
        disabled={isDisabled}
        name={name}
        options={options}
        componentsProps={{
          paper: { sx: { wordBreak: "break-word" } },
        }}
        getOptionLabel={(option) => option?.label}
        fullWidth
        clearIcon={allowClear ? undefined : null}
        autoComplete={false}
        ListboxProps={{ style: { minHeight: 0 } }}
        menuprops={{ style: { minHeight: 0 } }}
        PaperComponent={(props) => <Paper {...props} />}
        className="user_form_autoinput"
        size="small"
        renderInput={(params) => (
          <TextField
            autoFocus={autoFocus}
            size="small"
            {...params}
            placeholder={placeholder}
            error={error}
            helperText={helperText}
            FormHelperTextProps={{ style: { marginLeft: 0 } }}
            inputProps={{
              ...params.inputProps,
              readOnly: readOnly,
            }}
          />
        )}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        sx={ModifiedAutoComplete}
      />
    </div>
  );
}

export default CustomAutoCompleteDropdown;
